import type { InputOtpDesignTokens } from '@primeuix/themes/types/inputotp';

 export default {
    root: {
        gap: "0.5rem"
    },
    input: {
        lg: {
            width: "3rem"
        },
        sm: {
            width: "2rem"
        },
        width: "2.5rem"
    }
} satisfies InputOtpDesignTokens;